import privilegeActionTypes from './types';

export const confirmUserPrivileges = (type) => ({
  type,
});

export const verifyUserPrivileges = (roles) => {
  roles.map((item) => {
    item.role.privileges.map((privilege) => {
      const word = String(privilege.name)
        .replace(/:/g, '_')
        .replace(/-/g, '')
        .concat('_TRUE')
        .toUpperCase();
      confirmUserPrivileges(word);
    });
  });
};

export const setSuperAdmin = (payload) => ({
  type: privilegeActionTypes.SUPER_ADMIN,
  payload,
});

export const setSchoolDirector = (payload) => ({
  type: privilegeActionTypes.SCHOOL_DIRECTOR,
  payload,
});

export const setSchoolAdmin = (payload) => ({
  type: privilegeActionTypes.SCHOOL_ADMIN,
  payload,
});

export const setUserPrivileges = (payload) => ({
  type: privilegeActionTypes.SET_USER_PRIVILEGES,
  payload,
});

export const clearPrivileges = () => ({
  type: privilegeActionTypes.CLEAR_ALL_PRIVILEGES,
});
